"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _CrumbsCss = _interopRequireDefault(require("./Crumbs.css.js"));

var _Crumb = _interopRequireDefault(require("./Crumb"));

var _radium = _interopRequireDefault(require("radium"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Crumbs = function Crumbs(_ref) {
  var appState = _ref.appState,
      location = _ref.location;
  var vertical = appState.vertical,
      loan_type = appState.loan_type;
  var crumbData = appState.breadcrumbs;

  var _useState = (0, _react.useState)(location.pathname !== '/' && location.pathname !== '/verticals'),
      _useState2 = _slicedToArray(_useState, 2),
      showCrumbs = _useState2[0],
      setCrumbsVisible = _useState2[1];

  var _useState3 = (0, _react.useState)(location.pathname === '/email_optin'),
      _useState4 = _slicedToArray(_useState3, 2),
      isFinal = _useState4[0],
      setIsFinal = _useState4[1];

  (0, _react.useEffect)(function () {
    if (location.pathname === '/' || location.pathname === '/verticals') {
      setCrumbsVisible(false);
    } else {
      setCrumbsVisible(true);

      if (location.pathname === '/email_optin') {
        setIsFinal(true);
      }
    }

    ; // eslint-disable-next-line
  }, [location.pathname]);

  var TypeCrumb = function TypeCrumb() {
    switch (vertical) {
      case 'auto_loans':
        return /*#__PURE__*/_react.default.createElement("div", {
          key: "loan_type-crumb-".concat(loan_type),
          style: _CrumbsCss.default.crumbBox
        }, /*#__PURE__*/_react.default.createElement("span", {
          style: _CrumbsCss.default.crumbSpan
        }, "for a ", /*#__PURE__*/_react.default.createElement(_Crumb.default, {
          text: crumbData.loan_type,
          path: vertical
        })));

      case 'credit_cards':
        return /*#__PURE__*/_react.default.createElement("div", {
          key: "loan_type-crumb-".concat(loan_type),
          style: _CrumbsCss.default.crumbBox
        }, /*#__PURE__*/_react.default.createElement("span", {
          style: _CrumbsCss.default.crumbSpan
        }, "with ", /*#__PURE__*/_react.default.createElement(_Crumb.default, {
          text: crumbData.loan_type,
          path: vertical
        }), " benefits"));

      case 'personal_loans':
        return /*#__PURE__*/_react.default.createElement("div", {
          key: "loan_type-crumb-".concat(loan_type),
          style: _CrumbsCss.default.crumbBox
        }, /*#__PURE__*/_react.default.createElement("span", {
          style: _CrumbsCss.default.crumbSpan
        }, "to help with ", /*#__PURE__*/_react.default.createElement(_Crumb.default, {
          text: crumbData.loan_type,
          path: vertical
        })));

      case 'home_loans':
        return /*#__PURE__*/_react.default.createElement("div", {
          key: "loan_type-crumb-".concat(loan_type),
          style: _CrumbsCss.default.crumbBox
        }, /*#__PURE__*/_react.default.createElement("span", {
          style: _CrumbsCss.default.crumbSpan
        }, "to ", /*#__PURE__*/_react.default.createElement(_Crumb.default, {
          text: crumbData.loan_type,
          path: vertical
        })));

      default:
        return null;
    }
  };

  return showCrumbs && vertical !== 'direct' && vertical !== 'lincx' && /*#__PURE__*/_react.default.createElement("div", {
    key: "breadcrumb-container",
    style: _CrumbsCss.default.breadContainer
  }, /*#__PURE__*/_react.default.createElement("div", {
    key: "breadcrumb-row-1",
    style: _CrumbsCss.default.breadRow
  }, /*#__PURE__*/_react.default.createElement("div", {
    key: "vertical-crumb-".concat(vertical),
    style: _CrumbsCss.default.crumbBox
  }, /*#__PURE__*/_react.default.createElement("b", null, isFinal ? 'I\'m interested in ' : 'Search:'), /*#__PURE__*/_react.default.createElement(_Crumb.default, {
    text: crumbData.vertical,
    path: "verticals"
  })), crumbData.loan_type && /*#__PURE__*/_react.default.createElement(TypeCrumb, null)), crumbData.debt_type && /*#__PURE__*/_react.default.createElement("div", {
    key: "breadcrumb-row-2",
    style: _CrumbsCss.default.breadRow
  }, /*#__PURE__*/_react.default.createElement("div", {
    key: "debt-type-crumb",
    style: _CrumbsCss.default.crumbBox
  }, "of your ", /*#__PURE__*/_react.default.createElement(_Crumb.default, {
    text: crumbData.debt_type,
    path: "debt_types"
  })), crumbData.debt_amount && /*#__PURE__*/_react.default.createElement("div", {
    key: "debt-amount-crumb",
    style: _CrumbsCss.default.crumbBox
  }, "totaling ", /*#__PURE__*/_react.default.createElement(_Crumb.default, {
    text: crumbData.debt_amount,
    path: "debt_amount"
  }))));
};

var _default = (0, _radium.default)(Crumbs);

exports.default = _default;

//# sourceMappingURL=Crumbs.jsx.map